export default "__VITE_PUBLIC_ASSET__880935b2__"